import {
  WSDivider,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { ICreditCard } from "@wingspanhq/users";
import React from "react";
import { CreditCardBrandLogo } from "../../../components/CreditCardBrandLogo";
import { stripeCardBrandToCreditCardType } from "../../../types/creditCard";
import styles from "./CreditCardPreview.module.scss";

type Props = {
  paymentMethod: ICreditCard;
} & WSElementProps;

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const CreditCardPreview: React.FC<Props> = ({
  paymentMethod,
  ...elementProps
}) => (
  <WSElement {...elementProps}>
    <WSFlexBox wrap="nowrap" alignItems="center">
      <WSElement className={styles.logo} mr="S">
        <CreditCardBrandLogo
          type={stripeCardBrandToCreditCardType(paymentMethod.cardBrand)}
        />
      </WSElement>

      <WSText color="grey700">
        {capitalize(paymentMethod.cardBrand || "")} ••••{paymentMethod.last4}
      </WSText>

      {paymentMethod.expiryDate && <WSDivider vertical height="S" mx="S" />}

      {paymentMethod.expiryDate && (
        <WSText.LabelSmall color="grey600">
          Exp {paymentMethod.expiryDate.slice(0, 2)}/
          {paymentMethod.expiryDate.slice(3)}
        </WSText.LabelSmall>
      )}
    </WSFlexBox>
  </WSElement>
);
